export default "__VITE_ASSET__BagfkxtE__"